// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentProjectSearchResultActions_developmentProject_graphql = require("../../../__generated__/DevelopmentProjectSearchResultActions_developmentProject_graphql.bs.js");

let convertFragment = DevelopmentProjectSearchResultActions_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentProjectSearchResultActions_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultActions_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentProjectSearchResultActions_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentProjectSearchResultActions_developmentProject_graphql.node, convertFragment, fRef);
}

let ProjectFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentProjectSearchResultActions(props) {
  let match = RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultActions_developmentProject_graphql.node, convertFragment, props.project);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      href: `/developments/` + match.id,
      size: "small",
      className: "flex-1 justify-center",
      icon: "view-details",
      children: "View details"
    }),
    className: "flex gap-2"
  });
}

let make = DevelopmentProjectSearchResultActions;

exports.ProjectFragment = ProjectFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
